<script>
    import gsap from "gsap";
    import {onMount} from "svelte";
    import {labels, mainTimeline} from "../../timelines/main-timeline";

    const inTimeline = gsap.timeline();
    const outTimeline = gsap.timeline();

    const {circleStart, circleEnd, buildingEnd} = labels;

    onMount(() => {
        mainTimeline
            .from('#Boxes', {opacity: 0, duration: .5}, buildingEnd + '+=' + 1.2)
            .to('.tower-svg-elements', {
            motionPath: {
                path: '.circle-path',
                end: 1 - 5 * 0.03333,
            },
            ease: 'ease-out',
            duration: 3,
        },  buildingEnd + '+=' + 1.2);

        inTimeline
            .from('.tower-side-panel', {
                scaleY: 0,
                duration: 1,
                transformOrigin: 'bottom'
            })
            .from('.tower-top-panel', {
                y: 288,
                duration: 1,
                transformOrigin: 'bottom'
            }, '<')
            .to('.og-tower-box', {
                opacity: 0,
                duration: 0.15
            }, '<')
            .from('.glowing-line', {
                scaleY: 0,
                duration: 1,
                transformOrigin: 'bottom'
            }, '<+=0.6')
            .from(['.glowing-line-top', '.tower-top-cap'], {
                scaleY: 0,
                duration: 0.25,
                transformOrigin: 'bottom'
            }, '<+=0.8');

        outTimeline
            .to(['.glowing-line-top', '.tower-top-cap'], {
                scaleY: 0,
                duration: 0.1,
                transformOrigin: 'bottom'
            }, 0)
            .to('.glowing-line', {
                scaleY: 0,
                duration: 0.25,
                transformOrigin: 'bottom'
            }, '<')
            .to('.tower-side-panel', {
                scaleY: 0,
                duration: 0.25,
                transformOrigin: 'bottom'
            }, '<')
            .to('.tower-top-panel', {
                y: 288,
                duration: 0.25,
                transformOrigin: 'bottom'
            }, '<')
            .to('.og-tower-box', {
                opacity: 1,
                duration: 0.25
            }, '<')
            .to('#Boxes', {
                opacity: 0,
                duration: 0.25,
            })


        mainTimeline.add(inTimeline, buildingEnd + '+=4');
        mainTimeline.add(outTimeline, circleEnd);
    });
</script>

<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" overflow="visible" viewBox="0 0 51.16 319.05" width="50px" x="697" y="-190">
    <defs>
        <filter id="outer-glow-1" filterUnits="userSpaceOnUse">
            <feOffset dx="0" dy="0"/>
            <feGaussianBlur result="blur" stdDeviation="5"/>
            <feFlood flood-color="#cce6ff" flood-opacity=".1"/>
            <feComposite in2="blur" operator="in"/>
            <feComposite in="SourceGraphic"/>
        </filter>
        <filter id="outer-glow-2" filterUnits="userSpaceOnUse">
            <feOffset dx="0" dy="0"/>
            <feGaussianBlur result="blur-2" stdDeviation="5"/>
            <feFlood flood-color="#cce6ff" flood-opacity=".1"/>
            <feComposite in2="blur-2" operator="in"/>
            <feComposite in="SourceGraphic"/>
        </filter>
    </defs>
    <g id="Boxes" class="tower-svg-elements">
        <g class="tower-7">
            <path id="Path_43-2" class="tower-6 tower-side-panel" d="M25.58,316.66V38.28L1,24.1V302.47l24.58,14.19Z"/>
            <path id="Path_44-2" class="tower-6 tower-side-panel" d="M25.58,316.66V38.28l24.58-14.19V302.47l-24.58,14.19Z"/>
            <path id="Path_45-2" class="tower-6 tower-top-panel" d="M1,24.1L25.58,9.9l24.58,14.19-24.58,14.19L1,24.1Z"/>
        </g>
        <g>
            <polygon class="tower-3 glowing-line" points="44.26 31.36 47.15 29.68 47.15 251.2 44.26 252.88 44.26 31.36"/>
            <polygon class="tower-4 glowing-line" points="39.29 34.16 42.18 32.48 42.18 254 39.29 255.68 39.29 34.16"/>
            <polygon class="tower-1 glowing-line" points="34.32 36.97 37.21 35.29 37.21 256.8 34.32 258.49 34.32 36.97"/>
            <polygon class="tower-2 glowing-line" points="29.36 39.77 32.25 38.09 32.25 259.61 29.36 261.29 29.36 39.77"/>
        </g>
        <g>
            <polygon class="tower-3 glowing-line" points="6.91 31.36 4.02 29.68 4.02 251.2 6.91 252.88 6.91 31.36"/>
            <polygon class="tower-4 glowing-line" points="11.88 34.16 8.99 32.48 8.99 254 11.88 255.68 11.88 34.16"/>
            <polygon class="tower-1 glowing-line" points="16.84 36.97 13.95 35.29 13.95 256.8 16.84 258.49 16.84 36.97"/>
            <polygon class="tower-2 glowing-line" points="21.81 39.77 18.92 38.09 18.92 259.61 21.81 261.29 21.81 39.77"/>
        </g>
        <g>
            <polygon class="tower-6 tower-top-cap" points="25.46 20.22 25.46 32.33 42.18 22.72 42.18 10.61 25.46 20.22"/>
            <polygon class="tower-6 tower-top-cap" points="25.47 20.22 25.47 32.33 8.99 22.72 8.99 10.62 25.47 20.22"/>
            <g>
                <polygon class="tower-2 glowing-line-top" points="13.64 15.59 11.38 14.25 11.38 22.1 13.64 23.44 13.64 15.59"/>
                <polygon class="tower-5 glowing-line-top" points="18.15 18.23 15.91 16.91 15.91 24.76 18.15 26.08 18.15 18.23"/>
                <polygon class="tower-3 glowing-line-top" points="22.66 20.87 20.44 19.58 20.44 27.42 22.66 28.72 22.66 20.87"/>
            </g>
            <g>
                <polygon class="tower-2 glowing-line-top" points="37.42 15.46 39.61 14.25 39.61 22.1 37.42 23.31 37.42 15.46"/>
                <polygon class="tower-5 glowing-line-top" points="32.88 18.17 35.1 16.91 35.1 24.76 32.88 26.01 32.88 18.17"/>
                <polygon class="tower-3 glowing-line-top" points="28.33 20.87 30.58 19.58 30.58 27.42 28.33 28.72 28.33 20.87"/>
            </g>
            <polygon class="tower-6 tower-top-cap" points="8.99 10.62 25.47 20.22 42.18 10.61 25.68 1 8.99 10.62"/>
        </g>
        <!-- lower box-->
        <g class="tower-8 og-tower-box">
            <path id="Path_43-2-2" class="tower-6" d="M25.58,318.05v-28.38l-24.58-14.19v28.38l24.58,14.19Z"/>
            <path id="Path_44-2-2" class="tower-6" d="M25.58,318.05v-28.38l24.58-14.19v28.38l-24.58,14.19Z"/>
            <path id="Path_45-2-2" class="tower-6 tower-bottom-box-top-face" d="M1,275.49l24.58-14.19,24.58,14.19-24.58,14.19-24.58-14.19Z"/>
        </g>
        <g id="vanity-panel" class="tower-8 vanity-panel">
            <path id="Path_43-2-2" class="tower-6" d="M1,275.48v28.38l24.58,14.19v-28.38"/>
            <path id="Path_44-2-2" class="tower-6" d="M50.16,275.48v28.38l-24.58,14.19v-28.38"/>
        </g>
    </g>
</svg>

<style>
    .tower-1 {
        fill: #64bd64;
    }

    .tower-2 {
        fill: #96cc28;
    }

    .tower-3 {
        fill: #00a0dd;
    }

    .tower-4 {
        fill: #32afa1;
    }

    .tower-5 {
        fill: #4bb683;
    }

    .tower-6 {
        fill: #262a33;
        stroke: #fff;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 2px;
    }

    .tower-7 {
        filter: url(#outer-glow-1);
    }

    .tower-8 {
        filter: url(#outer-glow-2);
        transform: translateY(10px);
    }

    .vanity-panel {
        transform: translateY(10px);
        fill: none;
    }
</style>